import { 
  collection, 
  getDocs, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  doc, 
  query, 
  where,
  serverTimestamp 
} from 'firebase/firestore';
import { db, auth } from '../../config/firebase';

export const visionBoardApi = {
  // Obtener todas las tarjetas del usuario actual
  getCards: async () => {
    try {
      const cardsRef = collection(db, 'cards');
      const q = query(cardsRef, where('userId', '==', auth.currentUser?.uid || 'public'));
      const querySnapshot = await getDocs(q);
      
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
    } catch (error) {
      console.error('Error getting cards:', error);
      throw error;
    }
  },

  // Agregar una nueva tarjeta
  addCard: async (card) => {
    try {
      const cardsRef = collection(db, 'cards');
      const newCard = {
        ...card,
        userId: auth.currentUser.uid,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      };
      
      const docRef = await addDoc(cardsRef, newCard);
      return {
        id: docRef.id,
        ...newCard
      };
    } catch (error) {
      console.error('Error adding card:', error);
      throw error;
    }
  },

  // Actualizar una tarjeta existente
  updateCard: async (id, updates) => {
    try {
      const cardRef = doc(db, 'cards', id);
      const updatedCard = {
        ...updates,
        updatedAt: serverTimestamp()
      };
      
      await updateDoc(cardRef, updatedCard);
      return {
        id,
        ...updatedCard
      };
    } catch (error) {
      console.error('Error updating card:', error);
      throw error;
    }
  },

  // Eliminar una tarjeta
  deleteCard: async (id) => {
    try {
      const cardRef = doc(db, 'cards', id);
      await deleteDoc(cardRef);
      return id;
    } catch (error) {
      console.error('Error deleting card:', error);
      throw error;
    }
  }
}; 